<script lang="ts">
  import {Container} from '@/components';
  import {step} from '@/store';
  import {STEP} from '@/types/common';
  import {topnav} from '@/utils/top-nav-next-custom-events';
  import {onDestroy, onMount} from 'svelte';
  import VideoPlayer from './VideoPlayer.svelte';
  import recap, {Timestamp} from '@/store/recap';
  import PreviewEditor from './PreviewEditor.svelte';
  import {RecapService} from '@/services';
  import ConfirmationDialog from './ConfirmationDialog.svelte';

  let videoSrc = '';
  let timestamps: Timestamp[] = [];
  let recap_id = -1;

  const recapService = new RecapService();

  function updatePrevStep() {
    step.set(STEP.SELECT_INTRO);
    recapService.update(recap_id, {
      step: STEP.SELECT_INTRO
    });
  }

  let isConfirmationDialogVisible = false;

  async function showConfirmationDialog() {
    isConfirmationDialogVisible = true;
  }

  const recapSubscription = recap.subscribe(value => {
    recap_id = value.id;
    if (value.video_src) videoSrc = value.video_src;
    timestamps = [
      ...(JSON.parse(JSON.stringify(value.intro_timestamps)) || []),
      ...(JSON.parse(JSON.stringify(value.timestamps)) || [])
    ];
  });

  onMount(() => {
    topnav.previous(updatePrevStep);
    topnav.download(showConfirmationDialog);
  });

  onDestroy(() => {
    recapSubscription();
  });
</script>

<Container className="flex">
  <PreviewEditor />
  <div class="relative flex h-full flex-grow items-center overflow-auto">
    <VideoPlayer {videoSrc} {timestamps} />
  </div>
</Container>

<ConfirmationDialog bind:isConfirmationDialogVisible />
